/** Rounds to cents, avoiding binary floating point artifacts (1.005 → 1.01). */
export const roundCents = (value: number) => Math.round((value + Number.EPSILON) * 100) / 100;

const currencyFormatters = new Map<number, Intl.NumberFormat>();

/** User-facing MXN amount: `$188,282.55`. */
export function formatMoney(value: number | null | undefined, decimals = 2): string {
  let formatter = currencyFormatters.get(decimals);
  if (!formatter) {
    formatter = new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
    currencyFormatters.set(decimals, formatter);
  }
  return formatter.format(value ?? 0);
}

/** User-facing plain number: `1,605`. */
export const formatNumber = (value: number) => value.toLocaleString("es-MX");
